import { useEffect, useState } from "react";
import { getMarketPrices } from "../api";

// Live listed-asset prices, polled every 15s; shared shape from /api/markets/prices.
export const useLivePrices = () => {
  const [assets, setAssets] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = () => getMarketPrices().then((a) => alive && setAssets(a || [])).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  return assets;
};

export const MAJORS = ["BTC", "ETH", "SOL", "BNB", "XRP"];
export const STABLES = ["USDT", "USDC"];

export const fmtPrice = (p) => {
  if (p == null) return "—";
  const dp = p >= 1000 ? 2 : p >= 1 ? 4 : 6;
  return "$" + Number(p).toLocaleString("en-US", { minimumFractionDigits: Math.min(2, dp), maximumFractionDigits: dp });
};
export const fmtChange = (c) => (c == null ? "—" : `${c >= 0 ? "+" : "−"}${Math.abs(c).toFixed(2)}%`);
